import { render } from "./BaseAlert.vue?vue&type=template&id=73096bd4&scoped=true&ts=true"
import script from "./BaseAlert.vue?vue&type=script&lang=ts"
export * from "./BaseAlert.vue?vue&type=script&lang=ts"

import "./BaseAlert.vue?vue&type=style&index=0&id=73096bd4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73096bd4"]])

export default __exports__